import type { LeadScoringResponse } from "@io-spoke/contracts/leadScoring";
import { Badge } from "@components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@components/ui/card";

function formatBandLabel(band: LeadScoringResponse["band"]) {
  if (band === "high") {
    return "High fit";
  }
  if (band === "medium") {
    return "Medium fit";
  }
  return "Low fit";
}

function formatPercent(value: number) {
  return `${Math.round(value * 100)}%`;
}

export function LeadScoreCard({ result }: { result: LeadScoringResponse }) {
  return (
    <Card className="border-border/70">
      <CardHeader className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <CardTitle className="text-xl">Buyer fit</CardTitle>
          <CardDescription>
            Explainable scoring that highlights why this lead is worth your time.
          </CardDescription>
        </div>
        <div className="flex flex-col items-start gap-2 sm:items-end">
          <Badge variant={result.band === "high" ? "default" : "secondary"}>
            {formatBandLabel(result.band)}
          </Badge>
          <div className="text-3xl font-semibold tracking-tight">{result.score}</div>
          <div className="text-xs text-muted-foreground">{result.scoreVersion}</div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <h3 className="text-sm font-semibold text-foreground">Why this score</h3>
          <ul className="space-y-2">
            {result.rationale.map((item) => (
              <li
                key={item.key}
                className="rounded-lg border border-border/60 bg-muted/30 p-3"
              >
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="text-sm font-medium">{item.label}</div>
                  <div className="text-xs text-muted-foreground">
                    Contribution {formatPercent(item.contribution)}
                  </div>
                </div>
                {item.description ? (
                  <p className="mt-1 text-xs text-muted-foreground">{item.description}</p>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}

